import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { AcoService } from '../../../api/aco.service';
import { LoaderService } from '../../../services/loader.service';
import {AlertService} from '../../../services/alert.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() notificationsMemoryNews;
  @Input() employees;
  @Input() task_status_list;
  @Input() task_id;
  @Input() isNewTask;
  notifications = [];
  user_id = null;

  //mini formulario de objetos de notificación de usuarios
  user_ids = [];
  task_status_id = null;
  type_notification = null;
  notification = "";

  constructor(
    private modalController: ModalController,
    private aco: AcoService,
    private ionLoader: LoaderService,
    private alertService: AlertService
  ) { }

  ngOnInit() {

      // Si es nuevo
      if (this.isNewTask) {
          // Si es nuevo solo vinculamos esa lista a la del popup
           this.notifications = this.notificationsMemoryNews;
      } else {
          // Buscar en base de datos si estamos editando
          this.getNotifications();
      }
  }

  closeModal(){
    this.modalController.dismiss(this.notifications);
  }

  getNotifications(){

    this.ionLoader.showLoader();
    this.aco.getToken().then((a) => {
      this.aco.getNotificationsTask(this.task_id)
      .subscribe(
        (response) => {
          console.log(response);
          this.ionLoader.hideLoader();
          this.user_id = response['data']['user_id'];

          // Guardar en orden inverso para mostrar el chat mas reciente en ultima posición
          this.notifications = [];
          for(let notification of response['data']['notifications']){
            this.notifications.unshift(notification);
          }

          setTimeout(() => {
            this.contentScrollToBottom();
          }, 50);

        },
        (error) => {
          console.log('bad');
          this.ionLoader.hideLoader();
        }
      );
    });
  }

  contentScrollToBottom(){
    // Ir hasta el final del scroll
    this.content.scrollToBottom(100);
  }

  save_user_notification(){

    // Validar que ha rellenado l
    if(this.user_ids.length === 0 || this.task_status_id == null || this.type_notification == null ){
        this.alertService.presentToastMessage('Seleccione empleado, estado y notificación.');
        return;
    }

    // Buscar estado
    const status = this.task_status_list.find( (obj) => { return obj.id === this.task_status_id; });
    for (let i = 0; i < this.user_ids.length; i++) {

        // Buscar duplicado
        const existDuplicated = this.notifications.find( (obj) => {
            return obj.task_id === parseInt( this.task_id)
                && obj.user_id === parseInt(this.user_ids[i])
                && obj.task_status_id === parseInt(this.task_status_id)
        });

        // Si no hay registros iguales entonces guardamos
        if(existDuplicated == null) {

            // Buscar usuario
            const user = this.employees.find((obj) => {
                return obj.id === this.user_ids[i];
            });

            let notification = {
                'type_notification': this.type_notification,

                'task_status_code': status.code,
                'task_status_id': this.task_status_id,

                'user_name': user.name,
                'user_id': this.user_ids[i],

                'task_id': this.task_id
            };

            if (this.isNewTask) {
                this.save_notification_memory(notification);
            } else {
                // Guardar directamente en base de datos
                this.save_notification_memory(notification);
                this.save_notification_db(notification);
            }

            // Inicializar el formulario
            this.user_ids = [];
            this.task_status_id = null;
            this.type_notification = null;

            this.alertService.presentToastMessage('Guardado correctamente', 'orange');

        }else{
            this.alertService.presentToastMessage('Registro duplicado', 'orange');
        }

    }// for

  }

  /**
   * Guardar en la lista en memoria
   * @param notification
   */
  save_notification_memory(notification) {

    this.notification = "";

    // Añadir mensaje al chat
    this.notifications.push(notification);
    this.contentScrollToBottom();

  }

  /**
   * Persistir en base de datos
   * @param notification
   */
  save_notification_db(notification){

    // Guardar mensaje en BBDD
    this.aco.getToken().then((a) => {
      this.aco.setNotificationsTask(notification)
          .subscribe(
              (response) => {
                console.log(response);

                // Guardar en orden inverso para mostrar el chat mas reciente en ultima posición
                this.notifications = [];
                for(let notification of response['data']['notifications']){
                  this.notifications.unshift(notification);
                }

                setTimeout(() => {
                  this.contentScrollToBottom();
                }, 50);

              },
              (error) => {
              }
          );
    });
  }

  /**
   * Eliminar registro en base de datos y obtener lista actualizada
   * @param notification
   */
  delete_notification(task_id,user_id,task_status_id, type_notification ){

    let notification = {
      'task_status_id': task_status_id,
      'user_id': user_id,
      'task_id': task_id,
      'type_notification': type_notification
    };

      if (this.isNewTask) {

          // Obtener todos excepto el que se esta eliminando
          this.notifications = this.notifications.find( (obj) => {
              return obj.type_notification !== parseInt( type_notification)
                  && obj.user_id !== parseInt(user_id)
                  && obj.task_status_id !== parseInt(task_status_id)
          });

      } else {
          // Eliminamos en base de datos
          this.aco.getToken().then((a) => {
              this.aco.deleteNotificationsTask(notification)
                  .subscribe(
                      (response) => {
                          console.log(response);

                          // Guardar en orden inverso para mostrar el chat mas reciente en ultima posición
                          this.notifications = [];
                          for(let notification of response['data']['notifications']){
                              this.notifications.unshift(notification);
                          }

                          this.alertService.presentToastMessage('Eliminado correctamente', 'green');

                          setTimeout(() => {
                              this.contentScrollToBottom();
                          }, 50);

                      },
                      (error) => {
                      }
                  );
          });
      }
  }

  refresh(){
    this.getNotifications();
  }

}
